import oapiAxios from './axiosInstance';

const safeLocalStorageGet = (key) => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const value = window.localStorage.getItem(key);
    return value && value.trim ? value.trim() : value;
  } catch (err) {
    console.warn('LocalStorage read failed', err);
    return null;
  }
};

// The server attaches its own OrderWise token to every /oapi call, so there is nothing to fetch.
// Kept so existing callers that pass a token through still work.
export async function fetchOrderwiseToken() {
  return 'server-managed';
}

function buildOrderwiseHeaders(token, config = {}) {
  const headers = {
    ...(config.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
  const pimJwt = safeLocalStorageGet('token');
  if (pimJwt) {
    headers['X-PIM-JWT'] = pimJwt;
  }
  const accountNumberOverride = headers['X-Account-Number'] || headers['x-account-number'];
  const accountNumber = accountNumberOverride || safeLocalStorageGet('accountNumber');
  if (accountNumber) {
    headers['X-Account-Number'] = accountNumber;
  }
  return headers;
}

export async function postOrderwiseWithToken(path, body = [], config = {}) {
  const token = await fetchOrderwiseToken();
  if (!token) throw new Error('OrderWise token unavailable');
  return postOrderwise(path, body, token, config);
}

export async function getOrderwiseWithToken(path, params = {}, config = {}) {
  const token = await fetchOrderwiseToken();
  if (!token) throw new Error('OrderWise token unavailable');
  const headers = buildOrderwiseHeaders(token, config);
  const { data } = await oapiAxios.get(path, { ...config, params, headers });
  return data;
}

export async function postOrderwise(path, body, token, config = {}) {
  const headers = buildOrderwiseHeaders(token, config);
  const { data } = await oapiAxios.post(path, body, { ...config, headers });
  return data;
}
